// extracted by mini-css-extract-plugin
export default {"clientNames":"styles_clientNames__VJt90","names":"styles_names__rYXoG"};